import axios from "axios";
import { host } from "../../helper/config";
import { getItemPerPage } from "../../helper/helper";

const PLUGINS_NAME = "admin-game-periods";

// add period
export const addPeriods = async (
  token,
  name,
  gameId,
  startDate,
  startTime,
  numberPeriod,
  numberDays
) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/add-period`,
    {
      name: name,
      gameId: gameId,
      startDate: startDate,
      startTime: startTime,
      numberPeriod: numberPeriod,
      numberDays: numberDays,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data;
  }
  return false;
};

// keno
export const getKenoPeriods = async (token, query, page) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-keno`,
    {
      ...query,
      page: page,
      itemPerPage: getItemPerPage(),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

export const getLotto535Periods = async (token, page) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-lotto535`,
    { page, itemPerPage: getItemPerPage() },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  return response && response.status === 200 ? response.data || {} : {};
};

// max3d
export const getMax3dPeriods = async (token, query, page) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-max3d`,
    {
      ...query,
      page: page,
      itemPerPage: getItemPerPage(),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

// max3dpro
export const getMax3dProPeriods = async (token, query, page) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-max3dpro`,
    {
      ...query,
      page: page,
      itemPerPage: getItemPerPage(),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

// mega
export const getMegaPeriods = async (token, query, page) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-mega`,
    {
      ...query,
      page: page,
      itemPerPage: getItemPerPage(),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

// power
export const getPowerPeriods = async (token, query, page) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-power`,
    {
      ...query,
      page: page,
      itemPerPage: getItemPerPage(),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const getCurrentPeriodTicket = async (token) => {
  const response = await axios.get(
    `${host}/${PLUGINS_NAME}/get-current-period-ticket`,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return {};
};

export const getCurrentGamePeriods = async (token) => {
  const response = await axios.get(`${host}/${PLUGINS_NAME}/current-periods`, {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

export const getLatestPeriodByGame = async (token, gameId) => {
  const response = await axios.get(`${host}/${PLUGINS_NAME}/latest-period`, {
    params: {
      gameId,
    },
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: token,
    },
  });

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

export const updateCurrentGamePeriod = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/current-periods/update`,
    payload,
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

// delete period
export const deletePeriod = async (token, periodId) => {
  try {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/delete-period`,
      { periodId },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response && response.status === 200) {
      return response.data || { status: "success" };
    }
    return { status: "error", message: "Có lỗi xảy ra" };
  } catch (error) {
    return (
      error?.response?.data || {
        status: "error",
        message: "Có lỗi xảy ra khi xoá kỳ quay",
      }
    );
  }
};

// update period
export const updatePeriod = async (
  token,
  periodId,
  name,
  resultDate,
  resultTime
) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/update-period`,
    {
      periodId: periodId,
      name: name,
      resultDate: resultDate,
      resultTime: resultTime,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    }
  );

  if (response && response.status === 200) {
    return true;
  }
  return false;
};
